/** Tab ids from SM Roles & Permissions (shared information-screen tabs). */
export const RPE_INFORMATION_SCREEN_TAB_IDS = {
  statuscodes: 125,
  miscellaneous: 127,
  notes: 128,
  attachments: 129,
} as const;

export type RpeInformationScreenTabIds = typeof RPE_INFORMATION_SCREEN_TAB_IDS;
